import React, { useContext, useEffect } from "react";
import "./BundleBooking.css";
import { StateContext } from "../../../../StateProvider";
import NeedHelp from "../../../../Utilities/components/NeedHelp";
import Footer from "../../../../Footer";
import { BackButton } from "../../../../Utilities/components/Buttons";
import { useNavigate } from "react-router-dom";

function BundleBooking() {
  const navigate = useNavigate();
  const { loggedIn, bookingData, setBookingData, serviceDetails } =
    useContext(StateContext);

  const today = new Date();

  /* --------------------------------------------------
     🚫 Redirect if NOT logged in
  -------------------------------------------------- */
  useEffect(function () {
    if (loggedIn === false) {
      navigate("/login");
    }
  }, [loggedIn, navigate]);

  /* --------------------------------------------------
     Initialize bookingData
  -------------------------------------------------- */
  useEffect(function () {
    setBookingData(function (prev) {
      var updated = {};
      for (var k in prev) updated[k] = prev[k];

      updated.bookingType = "store/bundle";

      if (!updated.bookingInfo) {
        updated.bookingInfo = {
          selectedPackage: "",
          dateRange: [today, today]
        };
      }
      return updated;
    });
  }, []);

  /* --------------------------------------------------
     🔍 ES5 helper to locate bundle prices dynamically
  -------------------------------------------------- */
  function findBundlePrice(keyword) {
    if (!serviceDetails) return null;

    var categories = Object.keys(serviceDetails);
    var i, j;

    for (i = 0; i < categories.length; i++) {
      var list = serviceDetails[categories[i]];
      if (!list || !list.length) continue;

      for (j = 0; j < list.length; j++) {
        var svc = list[j];
        if (!svc || !svc.serviceName) continue;

        var name = String(svc.serviceName).toLowerCase();
        var k = String(keyword).toLowerCase();

        if (name.indexOf(k) !== -1) {
          return Number(svc.price);
        }
      }
    }
    return null;
  }

  var price10 = findBundlePrice("10");
  var price20 = findBundlePrice("20");

  var base10 = price10 != null ? price10 : 510;
  var base20 = price20 != null ? price20 : 960;

  /* --------------------------------------------------
     🧮 Build bundles array (ES5-safe)
  -------------------------------------------------- */
  var bundles = [
    {
      key: "10-Pack",
      label: "10-Day Bundle",
      color: "#4CA7DF",
      price: base10,
      days: 10,
      savings: "7%",
      perDay: (base10 / 10).toFixed(2),
      expiration: "90 Days",
      bestFor: "Casual daycare users"
    },
    {
      key: "20-Pack",
      label: "20-Day Bundle",
      color: "#FFB516",
      price: base20,
      days: 20,
      savings: "13%",
      perDay: (base20 / 20).toFixed(2),
      expiration: "90 Days",
      bestFor: "Frequent daycare guests"
    }
  ];

  /* --------------------------------------------------
     Handle Package Selection
  -------------------------------------------------- */
  function handlePackageSelect(key) {
    setBookingData(function (prev) {
      var updated = {};
      for (var k in prev) updated[k] = prev[k];

      var current = updated.bookingInfo || {};
      var same = current.selectedPackage === key;

      updated.bookingInfo = {
        selectedPackage: same ? "" : key,
        dateRange: current.dateRange
      };

      return updated;
    });
  }

  /* --------------------------------------------------
     Determine which bundle is selected
  -------------------------------------------------- */
  var selected = "";
  if (
    bookingData &&
    bookingData.bookingInfo &&
    bookingData.bookingInfo.selectedPackage
  ) {
    selected = bookingData.bookingInfo.selectedPackage;
  }

  /* --------------------------------------------------
     Component Return
  -------------------------------------------------- */
  return (
    <div>
      <div className="bundle-back-button-container">
        <BackButton />
      </div>

      <div className="bundle-container">
        <div className="bundle-header">
          <h2>Daycare Bundles</h2>
          <p>Buy more days, enjoy more savings and flexibility.</p>
        </div>

        <div className="bundle-chart">
          {
            (function () {
              var out = [];
              for (var i = 0; i < bundles.length; i++) {
                (function (bundle) {
                  var isSelected = selected === bundle.key;

                  out.push(
                    <div
                      key={bundle.key}
                      className={"bundle-card " + (isSelected ? "selected" : "")}
                      style={{
                        borderColor: bundle.color,
                        "--selected-color": bundle.color
                      }}
                      onClick={function () {
                        handlePackageSelect(bundle.key);
                      }}
                    >
                      <h3 style={{ color: isSelected ? "white" : bundle.color }}>
                        {bundle.label}
                      </h3>

                      <p className="bundle-price">${bundle.price}</p>

                      <div className="bundle-info">
                        <div>
                          <span className="info-label">Days Included:</span>
                          <span className="info-value">{bundle.days}</span>
                        </div>
                        <div>
                          <span className="info-label">Savings:</span>
                          <span className="info-value">{bundle.savings}</span>
                        </div>
                        <div>
                          <span className="info-label">Per-Day Rate:</span>
                          <span className="info-value">${bundle.perDay}</span>
                        </div>
                        <div>
                          <span className="info-label">Expiration:</span>
                          <span className="info-value">
                            {bundle.expiration}
                          </span>
                        </div>
                      </div>

                      <div className="bundle-footer">
                        <p className="bundle-tip">{bundle.bestFor}</p>

                        <button
                          className={
                            "bundle-select-btn " + (isSelected ? "active" : "")
                          }
                        >
                          {isSelected ? "Selected ✓" : "Select"}
                        </button>
                      </div>
                    </div>
                  );
                })(bundles[i]);
              }
              return out;
            })()
          }
        </div>
      </div>

      <div className="sign-up-section">
        <NeedHelp />
      </div>

      <Footer />
    </div>
  );
}

export default BundleBooking;
